import type { TrackerObject } from '@racemap/utilities/types/trackers';
import Link from 'antd/es/typography/Link';
import type { TableCellProps } from 'react-virtualized';
import { TrackerColumnKeys } from 'src/store/trackers/trackers_reducers';
import { Columns } from '../../../DataTable';
import { IconChartLine } from '../../../Icon';

interface CellProps extends TableCellProps {
  rowData: TrackerObject;
}

export const ChartColumn = () => {
  const cellRenderer = ({ rowData }: CellProps) => {
    const { trackerId } = rowData;
    return (
      <Link href={`/admin/track/${trackerId}`} target="_blank" rel="noopener noreferrer">
        <IconChartLine />
      </Link>
    );
  };

  return Columns.basicColumn({
    dataKey: TrackerColumnKeys.CHART,
    label: 'Chart',
    cellRenderer,
    minWidth: 70,
    maxWidth: 70,
    style: { justifyContent: 'center' },
    headerStyle: { justifyContent: 'center' },
    columnData: { hiddenOnDefault: true },
  });
};
